export type ReleaseNotesApp = 'desktop' | 'kundenportal';

export class ReleaseNoteTourStep {
    title: string;
    description: string;
    image?: string;
    video?: string;
    route?: string;
}

export class ReleaseNoteHighlight {
    title: string;
    description?: string;
    image?: string;
    video?: string;
    steps?: ReleaseNoteTourStep[];
    roles?: string[];
    apps?: ReleaseNotesApp[];
}

export class ReleaseNoteVersion {
    version: string;
    date: string;
    items: string[] = [];
    highlights?: ReleaseNoteHighlight[];
}

export class ReleaseNotesDialogInput {
    versions: ReleaseNoteVersion[] = [];
    currentVersion: string;
    showAllReleaseNotesLink = false;
}

export class ReleaseNoteTourStepView {
    featureTitle: string;
    version: string;
    versionDate: string;
    stepNumber: number;
    totalStepsInFeature: number;
    globalStepNumber: number;
    globalTotalSteps: number;
    title: string;
    description: string;
    image?: string;
    video?: string;
    route?: string;
    /** Nur für Anzeige in Kiene: Kennzeichnung reiner Kundenportal-Neuigkeiten */
    kundenportalOnly?: boolean;
    /** Abschnittswechsel Kiene → Kundenportal */
    sectionIntro?: boolean;
}

export function compareVersions(a: string, b: string): number {
    const pa = a.split('.').map(segment => parseInt(segment, 10) || 0);
    const pb = b.split('.').map(segment => parseInt(segment, 10) || 0);
    const length = Math.max(pa.length, pb.length);
    for (let i = 0; i < length; i++) {
        const diff = (pa[i] ?? 0) - (pb[i] ?? 0);
        if (diff !== 0) {
            return diff;
        }
    }
    return 0;
}

export function isYoutubeVideoUrl(url: string): boolean {
    return /youtube\.com|youtu\.be/i.test(url);
}

export function toYoutubeEmbedUrl(url: string): string {
    const shortMatch = url.match(/youtu\.be\/([^?&]+)/i);
    if (shortMatch?.[1]) {
        return `https://www.youtube.com/embed/${shortMatch[1]}`;
    }
    const longMatch = url.match(/[?&]v=([^?&]+)/i);
    if (longMatch?.[1]) {
        return `https://www.youtube.com/embed/${longMatch[1]}`;
    }
    if (url.includes('/embed/')) {
        return url;
    }
    return url;
}
